// apps/api/src/qxcircle/qxcircle-profile-seeds.ts
// Description: QXCircle profile metadata — real posts only on product.
// Owner: Masa Bayu
// Date: 2026-08-30

export type QxCircleProfileSeed = {
  authorHandle: string;
  authorName: string;
  bio: string;
};

export const QXCIRCLE_PROFILE_SEEDS: QxCircleProfileSeed[] = [];

export function findProfileSeed(handle: string): QxCircleProfileSeed | undefined {
  const normalized = handle.startsWith("@") ? handle : `@${handle}`;
  return QXCIRCLE_PROFILE_SEEDS.find((p) => p.authorHandle === normalized);
}
